import { CommonModule } from '@angular/common';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { IonicModule } from '@ionic/angular';
import { NgModule } from '@angular/core';
import { TranslateModule } from '@ngx-translate/core';

import { AccordionListComponent } from 'src/app/@shared/accordion-list/accordion-list.component';
import { ActionButtonGroupComponent } from 'src/app/@shared/action-button-group/action-button-group.component';
import { ActiveFilterChipsComponent } from 'src/app/@shared/active-filter-chips/active-filter-chips.component';
import { AppInfoComponent } from './app-info/app-info.component';
import { BypassSecurityTrustHtml } from 'src/app/@shared/bypass-security-trust-html.pipe';
import { BypassSecurityTrustUrl } from './bypass-security-trust-url.pipe';
import { ClusterFormComponent } from '../cluster/@shared/cluster-form/cluster-form.component';
import { ClusterPreviewComponent } from '../cluster/@shared/cluster-preview/cluster-preview.component';
import { ConditionalClickDirective } from 'src/app/@shared/conditional-click.directive';
import { ConfirmDirective } from 'src/app/@shared/confirm.directive';
import { ContactPersonPreviewComponent } from 'src/app/cluster/@shared/contact-person-preview.component';
import { ContentBlockComponent } from 'src/app/@shared/content-block/content-block.component';
import { DataReviewPreviewComponent } from 'src/app/data-review/@shared/data-review-preview/data-review-preview.component';
import { DatePickerComponent } from 'src/app/@shared/date-picker/date-picker.component';
import { DetailContentComponent } from 'src/app/@shared/detail/detail-content/detail-content.component';
import { DetailListItemComponent } from 'src/app/@shared/detail/detail-list-item/detail-list-item.component';
import { DynamicFormFieldComponent } from 'src/app/@shared/form/dynamic-form-field/dynamic-form-field.component';
import { ExportFieldSelectionComponent } from 'src/app/@shared/export/export-field-selection.component';
import { FilterPage } from 'src/app/filter/filter.page';
import { FormlosHeaderComponent } from 'src/app/@shared/formlos-header/formlos-header.component';
import { FormlosFooterComponent } from 'src/app/@shared/formlos-header/formlos-footer.component';
import { FormFieldComponent } from 'src/app/@shared/form/form-field/form-field.component';
import { HandleExternalLinksDirective } from './handle-external-links.directive';
import { HandleInternalLinksDirective } from './handle-internal-links.directive';
import { HandleKeyboardEventsDirective } from './handle-keyboard-events.directive';
import { HandleLinksDirective } from 'src/app/@shared/handle-links.directive';
import { ImageUploadComponent } from './image-upload/image-upload.component';
import { InfoBoxComponent } from 'src/app/@shared/info-box/info-box.component';
import { LanguageSwitchComponent } from './language-switch/language-switch.component';
import { NewDatasetButtonComponent } from 'src/app/@shared/new-dataset-button/new-dataset-button.component';
import { OrganizationFormComponent } from 'src/app/organization/@shared/organization-form/organization-form.component';
import { OrganizationPreviewComponent } from 'src/app/organization/@shared/organization-preview/organization-preview.component';
import { PasswordValidationComponent } from 'src/app/@shared/password-validation/password-validation.component';
import { PersonFormComponent } from 'src/app/person/@shared/person-form/person-form.component';
import { PersonPreviewComponent } from '../person/@shared/person-preview/person-preview.component';
import { ProtoImageComponent } from './proto-image/proto-image.component';
import { ProtoParallaxDirective } from './proto-parallax.directive';
import { ProtoVideoComponent } from './proto-video/proto-video.component';
import { ProtocolPreviewComponent } from 'src/app/protocol/@shared/protocol-preview/protocol-preview.component';
import { RoleListModalComponent } from 'src/app/role/role-list-modal/role-list-modal.component';
import { RolePreviewComponent } from 'src/app/role/@shared/role-preview/role-preview.component';
import { RouterLink, RouterOutlet } from '@angular/router';
import { SearchHighlightDirective } from 'src/app/@shared/search-highlight.directive';
import { SearchToolbarComponent } from 'src/app/@shared/search-toolbar/search-toolbar.component';
import { ShowHidePasswordComponent } from './show-hide-password/show-hide-password.component';
import { SplitPaneMainContentComponent } from 'src/app/@shared/split-pane-main/split-pane-main-content.component';
import { SplitPaneMainHeaderComponent } from 'src/app/@shared/split-pane-main/split-pane-main-header.component';
import { TopicFormComponent } from 'src/app/topic/@shared/topic-form/topic-form.component';
import { TopicPreviewComponent } from '../topic/@shared/topic-preview/topic-preview.component';
import { UnavailableBlockComponent } from 'src/app/@shared/unavailable-block/unavailable-block.component';
import { UserFormComponent } from 'src/app/user/@shared/user-form/user-form.component';
import { UserPreviewComponent } from 'src/app/user/@shared/user-preview/user-preview.component';

@NgModule({
  declarations: [
    AccordionListComponent,
    ActionButtonGroupComponent,
    ActiveFilterChipsComponent,
    AppInfoComponent,
    BypassSecurityTrustHtml,
    BypassSecurityTrustUrl,
    ClusterPreviewComponent,
    ClusterFormComponent,
    ConditionalClickDirective,
    ConfirmDirective,
    ContentBlockComponent,
    DataReviewPreviewComponent,
    DatePickerComponent,
    DetailContentComponent,
    DetailListItemComponent,
    DynamicFormFieldComponent,
    ExportFieldSelectionComponent,
    FilterPage,
    FormlosHeaderComponent,
    FormlosFooterComponent,
    FormFieldComponent,
    FormFieldComponent,
    HandleExternalLinksDirective,
    HandleInternalLinksDirective,
    HandleLinksDirective,
    HandleKeyboardEventsDirective,
    ImageUploadComponent,
    InfoBoxComponent,
    LanguageSwitchComponent,
    NewDatasetButtonComponent,
    OrganizationFormComponent,
    OrganizationPreviewComponent,
    SearchHighlightDirective,
    SearchToolbarComponent,
    PasswordValidationComponent,
    PersonFormComponent,
    PersonPreviewComponent,
    ProtocolPreviewComponent,
    ProtoImageComponent,
    ProtoParallaxDirective,
    ProtoVideoComponent,
    RoleListModalComponent,
    RolePreviewComponent,
    ShowHidePasswordComponent,
    SplitPaneMainContentComponent,
    SplitPaneMainHeaderComponent,
    TopicFormComponent,
    TopicPreviewComponent,
    UnavailableBlockComponent,
    UserFormComponent,
    UserPreviewComponent,
  ],
  exports: [
    ContactPersonPreviewComponent,
    AccordionListComponent,
    ActionButtonGroupComponent,
    ActiveFilterChipsComponent,
    AppInfoComponent,
    ClusterPreviewComponent,
    ClusterFormComponent,
    CommonModule,
    ConfirmDirective,
    ContentBlockComponent,
    DataReviewPreviewComponent,
    DatePickerComponent,
    DetailContentComponent,
    DetailListItemComponent,
    FormFieldComponent,
    FormsModule,
    ExportFieldSelectionComponent,
    FilterPage,
    FormlosHeaderComponent,
    FormlosFooterComponent,
    HandleExternalLinksDirective,
    HandleInternalLinksDirective,
    HandleLinksDirective,
    HandleKeyboardEventsDirective,
    ImageUploadComponent,
    InfoBoxComponent,
    IonicModule,
    LanguageSwitchComponent,
    NewDatasetButtonComponent,
    OrganizationFormComponent,
    OrganizationPreviewComponent,
    SearchHighlightDirective,
    SearchToolbarComponent,
    PasswordValidationComponent,
    PersonFormComponent,
    PersonPreviewComponent,
    ProtocolPreviewComponent,
    ProtoImageComponent,
    ProtoParallaxDirective,
    ProtoVideoComponent,
    ReactiveFormsModule,
    RoleListModalComponent,
    RolePreviewComponent,
    ShowHidePasswordComponent,
    SplitPaneMainContentComponent,
    SplitPaneMainHeaderComponent,
    TopicFormComponent,
    TopicPreviewComponent,
    TranslateModule,
    UnavailableBlockComponent,
    UserFormComponent,
    UserPreviewComponent,
  ],
  imports: [
    ContactPersonPreviewComponent,
    CommonModule,
    FormsModule,
    IonicModule,
    ReactiveFormsModule,
    TranslateModule,
    RouterOutlet,
    RouterLink,
  ],
})
export class SharedModule {
}
